import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TokenService } from '@services/token.service';

@Injectable({
    providedIn: 'root',
})
export class AuthCheckService {
    private jwtHelper = new JwtHelperService();

    constructor(private tokenService: TokenService) {}

    public get isLogged(): boolean {
        try {
            // Lógica movida do AuthService para cá
            return !this.jwtHelper.isTokenExpired(this.tokenService.token);
        } catch {
            return false;
        }
    }
}
